<template>
  <el-dialog
    :title="$t('reportCustomComponentFooterManage.confirmOperation')"
    :visible.sync="dialogVisible"
    width="500px"
    @close="handleClose">
    <div style="text-align: center; margin-bottom: 20px;">
      <p>{{$t('reportCustomComponentFooterManage.confirmDelete')}}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="handleConfirm">{{$t('common.confirmDelete')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteReportCustomComponentFooter } from '@/api/dev/reportCustomComponentFooterApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteReportCustomComponentFooter',
  data() {
    return {
      dialogVisible: false,
      deleteData: {}
    }
  },
  methods: {
    open(data) {
      this.deleteData = { ...data }
      this.dialogVisible = true
    },
    handleClose() {
      this.deleteData = {}
    },
    async handleConfirm() {
      try {
        this.deleteData.shopId = getShopId()
        await deleteReportCustomComponentFooter(this.deleteData)
        this.$emit('refresh')
        this.dialogVisible = false
        this.$message.success(this.$t('common.submitSuccess'))
      } catch (error) {
        console.error('删除失败:', error)
      }
    }
  }
}
</script>